<app-pro-import-map-submit-header [activeStep]="1"></app-pro-import-map-submit-header>

<div class="container">
    <app-loader *ngIf="isUploading" color="#50e3c2"></app-loader>
    <div class="file-select-box">
        <p class="header">Select PRO File</p>

        <input type="file" (change)="onFileSelected($event)" accept=".csv,.xlsx" style="display: none;" #fileInput />

        <button class="chose-file-button" (click)="fileInput.click()">

            <span id="chose-file-btn-content" *ngIf="selectedFile == null">
                <span>Choose File</span>

                <span>
                    <app-upload-icon></app-upload-icon>
                </span>
            </span>

            <span id="file-selected-btn-content" *ngIf="selectedFile != null">
                <span>
                    <span>{{selectedFile.name}}</span>
                </span>

                <span>
                    <app-delete-icon></app-delete-icon>
                </span>
            </span>

        </button>
        <p class="small-info-text">The maximum file upload size is 1GB</p>
    </div>

    <div class="type-select">
        <mat-form-field class="type-form-field">
            <mat-label>P.R.O TYPE</mat-label>
            <mat-select class="type-select-field" panelClass="import-select" [(ngModel)]="importType"
                (ngModelChange)="setImportType()">
                <mat-option *ngFor="let type of importTypes" [value]="type">{{type}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="year-and-quarter-select">
        <mat-form-field class="year-and-quarter-form-field">
            <mat-label>YEAR</mat-label>
            <mat-select class="year-and-quarter-select-field" panelClass="import-select" [(ngModel)]="importYear"
                (ngModelChange)="setImportYear()">
                <mat-option *ngFor="let year of importYears" [value]="year">{{year}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="year-and-quarter-form-field">
            <mat-label>QUARTER</mat-label>
            <mat-select class="year-and-quarter-select-field" panelClass="import-select"
                [(ngModel)]="importQuarter" (ngModelChange)="setImportQuarter()">
                <mat-option *ngFor="let quarter of importQuarters" [value]="quarter">{{quarter}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div>
        <button class="import-button" (click)="uploadPRO()" [disabled]="isUploading">IMPORT</button>
    </div>

</div>